/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ActiveAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import CheckRequirements from './CheckRequirements/index'
import CreateProcedureReceivables from './CreateProcedureReceivables/index'
import No from './No/index'
import React from 'react'
import StatusUpdate from './StatusUpdate/index'
import TaskInsert from './TaskInsert/index'
import TaskInsertNew from './TaskInsertNew/index'



/** @type {import('Simple/types.js').View} */
export default function ActiveAction({
  children,
  viewPath = "/DesignSystem/ManualAutomations/Content/Content/ActiveAction"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let selectedActionTypeValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'action_type',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: selectedActionTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'TaskInsert'}>
<TaskInsert
  viewPath={`${viewPath}/TaskInsert`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'TaskInsertNew'}>
<TaskInsertNew
  viewPath={`${viewPath}/TaskInsertNew`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'StatusUpdate'}>
<StatusUpdate
  viewPath={`${viewPath}/StatusUpdate`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'CheckRequirements'}>
<CheckRequirements
  viewPath={`${viewPath}/CheckRequirements`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'CreateProcedureReceivables'}>
<CreateProcedureReceivables
  viewPath={`${viewPath}/CreateProcedureReceivables`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}